import axios from "axios";
import Player from "@vimeo/player";
import { EventHandler } from "./eventHandler";
import * as Utils from "./utils";

var body = document.querySelector("body"),
    videoOverlay = document.querySelector(".js-video-overlay"),
    videos = [],
    videoArray = [],
    videoMaxH,
    videoMaxHRatio,
    setupRun = false,
    ratio = 0.5625, // 9 / 16
    userAgent = {
        string: navigator.userAgent.toLowerCase(),
    };

export function init() {
    // For android, some videos were failing to get into the onload state. The visibility
    // fix is not needed for Android anyway so just show
    if (userAgent.android) {
        body.classList.add("visible-iframes");
    }

    // On clicking a play video link
    body.addEventListener("click", (e) => {
        var $this = e.target.closest(".js-play-video-link");

        if (!$this) {
            return;
        }

        var videoId = $this.dataset.videoId,
            videoObj = videoArray.filter((obj) => obj.id === videoId)[0],
            player,
            playerIdIncrement,
            postData;

        e.preventDefault();

        // If we are not allowed to do this, don't go on
        // if (preventAction) {
        //     return;
        // }

        // If we already have the video with this id
        if (videoObj) {
            // Get the existing player
            player = videoObj.player;

            videoOverlayClickInit(player);

            prepareToPlay(videoObj);

            // For android devices other than Chrome, this doesn't play in full screen
            // mode, which looks odd.
            if (!userAgent.android || userAgent.androidChrome) {
                playVideo(player);
            }
        } else {
            // Increment the player id based on the number of videos we have on the page
            playerIdIncrement = videos.length + 1;

            // Create the post data object
            postData = {
                videoId: videoId,
                playerId: playerIdIncrement,
            };

            // Request the video with this id
            axios
                .post(`/includes/video`, postData, {
                    headers: { "X-Requested-With": "XMLHttpRequest" },
                })
                .then(function (response) {
                    // Append items to list
                    let returnData = Utils.stringToHTML(response.data);

                    const videoHTML = returnData.querySelector(".js-video");

                    // Add the requested element to it's container
                    document
                        .querySelector(".js-video-container")
                        .appendChild(videoHTML);

                    // Add this video to the jQuery object
                    videos = document.querySelectorAll(".js-video");

                    // If setup has not run yet, run it
                    if (!setupRun) {
                        setup();
                    }

                    // Create a new Vimeo API player using the new player's id
                    player = new Player(
                        document.querySelector("#player_" + playerIdIncrement)
                    );

                    // Construct the object for the array
                    videoObj = {
                        id: videoId,
                        player: player,
                    };

                    // Add this new video to our array
                    videoArray.push(videoObj);

                    prepareToPlay(videoObj);

                    // This was failling on Android Chrome due to the delay between the initial
                    // click event and the AJAX call. Also, it is best to play this in full
                    // screen mode for Android as this is what would be expected. Also,
                    // this gives a much cleaner transition with the video overlay fading
                    // up and the move to full-screen as Android full screen has a
                    // similarly dark background
                    if (!userAgent.android) {
                        playVideo(player);
                    }

                    videoOverlayClickInit(player);

                    // On video end, hide the overlay
                    player.on("ended", function () {
                        closeVideo();
                    });
                })
                .catch(function (error) {
                    console.error(error);
                });
        }
        // Prevent jump on clicking the close video overlay link
    });

    body.addEventListener("click", (e) => {
        var $this = e.target.closest(".js-close-video");

        if (!$this) {
            return;
        }

        e.preventDefault();
    });

    // On mousewheeling on the page overlay, don't allow the page to scroll
    videoOverlay.addEventListener(
        "mousewheel  DOMMouseScroll  MozMousePixelScroll",
        (e) => {
            e.preventDefault();
        }
    );
}

function showOverlay(overlay) {
    if (!!overlay.forEach) {
        overlay.forEach((el) => {
            el.classList.add("reveal");
        });

        return;
    }

    overlay.classList.add("reveal");
}

function hideOverlay(overlay) {
    if (!!overlay.forEach) {
        overlay.forEach((el) => {
            el.classList.remove("reveal");
        });

        return;
    }

    overlay.classList.remove("reveal");
}

function setup() {
    // Set the variables which require a video element on the page
    videoMaxH = videos.maxHeight;
    videoMaxHRatio = parseInt(videoMaxH) / 100;

    // On clicking the page overlay, fade it out
    videoOverlay.addEventListener("click", fadeOut);

    // Set the flag to say this has run
    setupRun = true;
}

function sizeAndFitVideo() {
    var newVideoMaxH = window.innerHeight * videoMaxHRatio,
        videoW,
        newVideoH;

    // Reset any inline widths and heights
    videos.forEach((video) => {
        video.style.width = "";
        video.style.height = "";
    });

    // Now set the variables
    videoW = videos[0].clientwidth;
    newVideoH = videoW * ratio;

    // If the calculated height based on the width is going to be too high for the
    // window, set the width based on the max height, otherwise, set the height
    videos.forEach((video) => {
        if (newVideoH > newVideoMaxH) {
            video.style.width = newVideoMaxH / ratio;
            video.style.height = videoMaxH;
        } else {
            video.style.height = videoW * ratio;
        }
    });
}

function showOnlyThisVideo(id) {
    // Hide all videos then show only the one which has this id
    videos.forEach((video) => video.classList.remove("show", "js-show"));

    [...videos]
        .filter((video) => video.dataset.id === id)
        .forEach((video) => video.classList.add("show", "js-show"));
}

function playVideo(player) {
    // Play the video
    player.play().catch(function (error) {
        console.error("error playing the video:", error.name);
    });
}

function pauseVideo(player) {
    // Pause the video
    player.pause().catch(function (error) {
        console.error("error pausing the video:", error.name);
    });
}

function videoOverlayClickInit(player) {
    // Remove any previous click listeners on the page overlay and add new
    // videoOverlay.removeEventListener("click", closeVideo());
    videoOverlay.addEventListener("click", function (e) {
        closeVideo(player);
    });
}

function fadeOut() {
    hideOverlay(videoOverlay);
}

function closeVideo(player) {
    // Remove any video listeners
    EventHandler.removeEventListener("resize.video  keydown.video");

    // If we have been passed a player
    if (player) {
        // Pause it
        pauseVideo(player);
    }

    fadeOut();
}

function videoListenersInit(player, initialSize) {
    // This is all handled at full screen for android and this function was causing
    // the stock browser to pause videos (and so close the overlay)
    if (!userAgent.android) {
        // Set up the resize and keydown functions
        EventHandler.removeEventListener("resize.video  keydown.video");

        EventHandler.addEventListener("resize.video", function () {
            raf(sizeAndFitVideo);
        });

        EventHandler.addEventListener("keydown.video", function (e) {
            var keyCode = e.keyCode;

            e.preventDefault();

            // If this is escape or enter, close the video
            if (keyCode === 27 || keyCode === 13) {
                closeVideo(player);
            }
        });
    }

    // If we need to run an initial sizing function, do so
    if (initialSize) {
        sizeAndFitVideo();
    }
}

function prepareToPlay(videoObj) {
    var id = videoObj.id;

    showOnlyThisVideo(id);

    videoListenersInit(videoObj.player, id);

    showOverlay(videoOverlay);
}

function raf(callback) {
    window.requestAnimationFrame(callback);
}
